import Storefront from './storefront';
import OnlineOrdering from './online-ordering';

export default {
  Storefront,
  OnlineOrdering,
};
